import cn from 'classnames';
import styles from './Checkbox.module.scss';
import { ChangeEvent } from 'react';

type CheckboxProps = {
  className?: string;
  checked?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
};

export function Checkbox({ className, checked, onChange }: CheckboxProps) {
  const wrapperClassName = cn(styles.input, className);

  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      className={wrapperClassName}
    />
  );
}
